import { ARTICLE_ACTION_TYPES } from '../../actions/article/article_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: []
};

export const articles = (state = initialState, action) => {
    switch (action.type) {
        case ARTICLE_ACTION_TYPES.GET_ARTICLES_SUCCESS:
            return { ...state, collection: action.payload };
        case ARTICLE_ACTION_TYPES.POST_ARTICLE_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case ARTICLE_ACTION_TYPES.PUT_ARTICLE_SUCCESS:
            const updatedArticle = action.payload;
            return { ...state, collection: state.collection.map((article) => article.uuid !== updatedArticle.uuid ? article : { ...article, ...updatedArticle }) };
        case ARTICLE_ACTION_TYPES.UPDATE_ARTICLES_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
